import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import goodsCategoryApi from '../../api/goodsCategory';
import { message } from 'antd';

// 获取商品分类树状结构
export const fetchCategoryTree = createAsyncThunk(
  'goodsCategory/fetchTree',
  async (searchParams = {}, { rejectWithValue }) => {
    try {
      const response = await goodsCategoryApi.getCategoryTree(searchParams);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// 创建商品分类
export const createCategory = createAsyncThunk(
  'goodsCategory/create',
  async (categoryData, { dispatch, rejectWithValue }) => {
    try {
      const response = await goodsCategoryApi.createCategory(categoryData);
      message.success('分类创建成功');
      dispatch(fetchCategoryTree());
      return response.data;
    } catch (error) {
      message.error('分类创建失败');
      return rejectWithValue(error.response.data);
    }
  }
);

// 更新商品分类
export const updateCategory = createAsyncThunk(
  'goodsCategory/update',
  async (categoryData, { dispatch, rejectWithValue }) => {
    try {
      const response = await goodsCategoryApi.updateCategory(categoryData);
      message.success('分类更新成功');
      dispatch(fetchCategoryTree());
      return response.data;
    } catch (error) {
      message.error('分类更新失败');
      return rejectWithValue(error.response.data);
    }
  }
);

// 删除商品分类
export const deleteCategory = createAsyncThunk(
  'goodsCategory/delete',
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const response = await goodsCategoryApi.deleteCategory(id);
      message.success('分类删除成功');
      dispatch(fetchCategoryTree());
      return response.data;
    } catch (error) {
      message.error('分类删除失败');
      return rejectWithValue(error.response.data);
    }
  }
);

// 切换分类状态已移除，现在通过 updateCategory 实现状态切换

const goodsCategorySlice = createSlice({
  name: 'goodsCategory',
  initialState: {
    categoryTree: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoryTree.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategoryTree.fulfilled, (state, action) => {
        state.loading = false;
        console.log("goodsCategorySlice:",action.payload);
        state.categoryTree = action.payload;
      })
      .addCase(fetchCategoryTree.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default goodsCategorySlice.reducer; 